import React from "react";
import "../../index.scss";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "../../index.scss";
import "./Responsive.scss";

const NadezdaPetrovicText = () => {
  return (
    <Container
      sm={{ span: 12 }}
      md={{ span: 12 }}
      lg={{ span: 12 }}
      xl={{ span: 12 }}
      className="container-artist-data"
    >
      <Row>
        <Col
          sm={{ span: 12 }}
          md={{ span: 11, offset: 1 }}
          lg={{ span: 11, offset: 0 }}
          xl={{ span: 11, offset: 0 }}
        >
          <div className="artist-info-text" style={{ width: "100%" }}>
            <p style={{ color: "black" }}>
              <font color="black">
                <b>Nadežda Petrović </b>
              </font>
              je rođena 11. oktоbra 1873. u Čačku. Otac Dimitrije Mita Petrović
              je bio nastavnik crtanja u Realnoj gimnaziji u Čačku, a majka
              Mileva Zorić je bila učiteljica. Nadežda je najstarija od devetoro
              dece koje su imali.
              <br />
              <br />
              <div>1879.</div>
              Sa porodicom prelazi u Karanovac (Kraljevo) zbog službe roditelja.
              <br />
              <br />
              <div>1884.</div>
              Porodica Petrović odlazi za Beograd. Prve osnove iz slikarstva
              dobija od svog ujaka Svetozara Zorića kasnije nastavnika istorije
              umetnosti, stila i ornamentike u školi Kirila Kutlika. Iste godine
              upoznaje cenjenog slikara Đorđa Krstića, očevog prijatelja.
              <br />
              <br />
              <div>1891.</div>
              Završava Višu žensku školu u Beogradu. Slikarstvo uči kod Đorđa
              Krstića sve do odlaska u Minhen 1898. Jedine sačuvane slike iz
              vremena Krstićevih pouka su <i>
                Mrtva priroda sa crvenim sudom
              </i>{" "}
              (1898.) i <i>Betoven</i> (1898.)
              <br />
              <br />
              <div>1892.</div>
              Piše molbu Ministarstvu prosvete da joj se omogući da predaje kao
              nastavnica crtanja. Polaže ispit za nastavnicu crtanja pred
              komisijom koju su sačinjavali: Mihailo Valtrović, Đorđe Krstić,
              Dimitrije Andrejević.
              <br />
              <br />
              <div>1893.</div>
              Postaje učiteljica crtanja u Višoj ženskoj školi u Beogradu.
              <br />
              <br />
              <div>1896. i 1897.</div>
              Pohađa školu (žensko odeljenje) Kirila Kutilika u Beogradu. Škola
              je davala osnovna predznanja za dalje likovno obrazovanje. Kroz
              školu je prošla generacija budućih slikara: Bora Stevanović, Milan
              Milovanović, Kosta Milićević, Dragomir Glišić...
              <br />
              <br />
              <b>MINHEN</b>
              <br />
              <br />
              <div>1898.</div>
              Piše molbu Ministru prosvete i crkvenih poslova Andri Đorđeviću,
              da joj odobri odsustvo od dužnosti učiteljice radi usavršavanja na
              Minhenskoj akademiji. Molba je pozitivno rešena. Ona odlazi u
              Minhen na školovanje kod Antona Ažbea gde će upoznati slikare:
              Borivoja Stevanovića, Milana Milovanovića, Ivana Grohara i druge.{" "}
              <br />
              I pored toga što žene još uvek nisu imale pravo da pohađaju
              Akademiju umetnosti u Minhenu, Akademija će ipak overiti i
              priznati Ažbeove diplome. Kod Ažbea ostaje do 1901. <br />
              Za vreme njenog školovanja u Minhenu, 3. marta 1898. rodio se njen
              najmlađi brat Rastko Petrović.
              <br />
              <br />
              <div>1899.</div>
              Na putu od Beograda ka Minhenu obilazi Zagreb, Fijumi (Rijeku),
              Trst i III Bijenale u Veneciji. U Minhenu proučava dela iz
              Pinakoteke, secesiju i upoznaje se sa ruskim krugom umetnika
              Jevlenskim, Kandinskim, Minterom, Verefkinovom. Upoznaje i Riharda
              Jakopiča i Matiju Jamu. Iste godine upisuje se u Državnu školu za
              primenjenu umetnost i zato dobija veću stipendiju od Ministarstva
              privrede. Sve vreme bavi se fotografijom.
              <br />
              <br />
              <div>1900.</div>
              Posećuje izložbu Minhenske secesije. Prvi put vidi slike
              francuskih slikara Koroa, Monea, Renoara i Sisleja. <br />
              U Sali Velike škole u Beogradu otvara svoju prvu samostalnu
              izložbu. Pera Odavić piše oštru kritiku o izložbi u časopisu Nova
              iskra.
              <br />
              <br />
              <div>1901.</div>
              Putuje po Nemačkoj. U Berlinu na izložbi Secesije upoznaje se sa
              delima Monea, Pisaroa, Renoara, Tuluza Lotreka, Beklina, Korinta i
              Ekstera. Posle školovanja kod Ažbea prelazi kod Juliusa Ekstera,
              profesora Minhenske akademije i potpisnika memoranduma Minhenske
              secesije. Počinje da radi na otvorenom, u pleneru nastaju motivi
              prirode i pejzaža. U tom periodu nastaje slika{" "}
              <i>Put kroz jelovu šumu</i>.<br />
              <br />
              <div>1902.</div>
              Nastavlja školovanje kod Ekstera. U Beču posećuje prolećnu izložbu
              u palati Secesije gde vidi <i>Betovenov friz</i> Gustava Klimta
              koji u akademskim krugovima toga vremena izaziva dosta polemike.
              Aktivno slika u okolini Minhena. Tad nastaju značajna dela
              kolorističke faze Nadeždinog stvaralaštva među kojima i{" "}
              <i>Stablo u šumi</i>.<br />
              <br />
              <b>SRBIJA</b>
              <br />
              <br />
              <div>1903.</div>U Beču posećuje izložbu impresionistа i
              postimpresionistа. Nastaje delo <i>Iz Iberzea</i>. Ovo je godina
              njenog povratka u Srbiju. Počinje sa političkim, društvenim i
              humanističkim angažamanom. Saradnica je većine listova u Srbiji.
              Piše o slikarstvu i likovnoj umetnosti, školstvu i potrebama
              modernizacije nastave, o obrazovanju ženske omladine i
              emancipaciji žena, o pozorištu, muzici i dr. Podržava ideju
              oslobođanja južnoslovenskih naroda. Organizuje veliki ženski skup
              gde se zalaže za buđenje patriotske svesti žena, za političku i
              socijalnu pravdu, za prikupljanje pomoći Srbima izvan Srbije.
              Osniva Kolo srpskih sestara i postaje prvi sekretar ove
              organizacije. Putuje u Makedoniju i nosi pomoć postradalom življu.
              Piše svoju jedinu pozorišnu dramu izrazito političkog karaktera{" "}
              <i>O živim slikama iz Makedonije i Srbije</i>.<br />
              <br />
              <div>1904.</div>
              Učestvuje u osnivanju i organizovanju Prve jugoslovenske umetničke
              izložbe. Povod za izložbu bila je stogodišnjica Prvog srpskog
              ustanka i krunisanje Petra I Karađorđevića. Učesnici-izlagači na
              izložbi su bili srpski, hrvarski, slovenački i bugarski umetnici
              čime je afirmisana južnoslovenska ideja. Izložbu je otvorio kralj
              Petar I, koji je otkupio 41 delo i odlikovao najistaknutije
              umetnike. Od nekoliko slika koje je Nadežda ponudila za izložbu,
              žiri je prihvatio samo sliku <i>Žetva</i>. Kritike o izložbi pored
              Nadežde Petrović pišu i Bogdan Popović, Miloje Vasić, Vladimir
              Petković, Vladislav Petković Dis. Nadežda učestvuje u dogovoru oko
              osnivanja Prve jugoslovenske umetničke kolonije. Ideja kolonije je
              da okupi grupu maldih jugoslovenskih umetnika čija bi likovna
              delatnost činila osnovu nove jugoslovenske savremene umetnosti.
              Inicira i ideju za osnivanje Jugoslovenske umetničke galerije.
              Učestvuje u osnivanju Saveza jugoslovenskih umetnika „Lada”, čija
              je svrha zajednička borba svih jugoslovenskih umetnika na polju
              jugoslovenske umetnosti. To je period nastanka njenih slika,{" "}
              <i>Resnik (Višnjica)</i> i <i>Staro groblje</i>. Odlikovana je
              Ordenom Svetog Save IV stepena.
              <br />
              <br />
              <div>1905.</div>
              Na međunarodnu izložbu u Liježu, na kojoj nastupa “Lada”, Nadežda
              Petrović nije pozvana. Boravi u Minhenu, Beču i Zagrebu gde
              prisustvuje jubileju "Hrvatskog društva umjetnosti" i izložbi za
              koju piše kritiku. U okolini Sićeva počinje sa radom Prva
              jugoslovenska umetnička kolonija koju čine Nadežda Petrović, Ferdo
              Vesel, Rihard Jakopič, Ivan Grohar i Paško Vučetić, kasnije se
              pridružuju Ivan Meštrović i Emanuel Vidović. Umetnici izlaze u
              prirodu i slikaju predele Sićeva. Tada nastaju Nadeždine slike:{" "}
              <i>Ciganka sa crvenim šalom</i>, <i>Pogreb u Sićevu</i>.<br />
              <br />
              <div>1906.</div>
              Otvorena je Prva izložba “Lade” u prostorijama Srpskog
              poljoprivrednog društva. Izložbu je otvorio kralj Petar I. Nadežda
              izlaže pejzaže i portrete koji su rezultat njenog rada u Koloniji.
              Kritika joj nije blagonaklona izuzev kritike Branka Popovića. Na
              Drugoj jugoslovenskoj izložbi u Sofiji “Lada” po drugi put ne
              prihvata Nadeždino učešće što će biti razlog za njen odlazak iz
              “Lade”. Radi na pripremi izložbe Jugoslovenske umetničke kolonije
              koja je imala za cilj da afirmiše napredne umetničke ideje i
              predstavi grupu modernih likovnih stvaralaca na početku 20 veka.
              <br />
              <br />
              <div>1907.</div>
              Otvorena izložba Jugoslovenske umetničke kolonije u prostorijama
              Narodnog muzeja. Među učesnicima pored Nadežde Petrović su i Paško
              Vučetić, Ivan Grohar, Matija Jama, Rihard Jakopič, Ivan Meštorvić,
              Emanuel Vidović, Tomislav Krizman, Mirko Rački, Ante Katunarić,
              Nikola Mihailov i Aleksandar Božinov. Nadežda izlaže slike{" "}
              <i>Ribari na Dunavu</i>, <i>Jesen</i>, <i>Na kladencu</i> i dr.
              Kritika je primećuje ali i dalje nema razumevanja za njen rad.{" "}
              <br />
              Česti gosti porodice Petrović bili su svi članovi kolonije. Ivan
              Grohar boravi par meseci u kući Petrovića, tada nastaje njegov{" "}
              <i>Portret Nadežde Petrović</i> u pastelu. Podstiče je da uradi{" "}
              <i>Autoportret</i>. <br />
              Nadežda posećuje, Beč, Minhen, Veneciju i Rim. Sa Brankom
              Popovićem obilazi VII bijenale u Veneciji gde upoznaje dela
              Sinjaka, Vijara, Ensora... Tada nastaju slike:{" "}
              <i>Selo (Cigansko predgrađe)</i>, <i>Portret Branka Popovića</i>,{" "}
              <i>Portret Jovana Skerlića</i>, <i>Koloseum</i> i <i>Pompeji</i>.
              Ona je osnivač Srpskog umetničkog udruženja. <br />
              To je period nastanka ključnih dela srpskog impresionizma među
              kojima su i Nadeždine slike: <i>Dereglije na Savi</i>,{" "}
              <i>Karaula na Savi</i>, <i>Devojka sa suncobranom</i>.<br />
              <br />
              <div>1908.</div>
              Izlaže na izložbi Srpskog umetničkog udruženja u Beogradu. Odlazi
              na Sveslovenski kongres u Prag gde se zalaže za priređivanje
              sveslovenske umetničke izložbe. Putuje u Ljubljanu na Osmi
              sveslovenski kongres novinara kada kao gost boravi kod Riharda
              Jakopiča. Posećuje Prvu dalmatinsku izložbu u Splitu na kojoj
              izlažu njeni prijatelji Meštrović, Vučetić i Vidović. Piše kritiku
              izložbe. Pored ove daje i kritiku izložbe Paška Vučetića.
              <br />
              Povodom aneksije Bosne i Hercegovine (6. oktobra) Nadežda
              organizuje protestni skup žena i pokret za bojkot austrougarske i
              nemačke robe. Na balkonu Narodnog pozorišta drži politički govor.
              Postaje član patriotskog društva Narodna odbrana.
              <br />
              <br />
              <div>1909.</div>
              Putuje u Minhen i Berlin sa Brankom Popovićem. Piše kritiku za
              Drugu izložbu “Lade”. Upućuje molbu Ministarstvu prosvete i
              Državnom savetu da joj se poveća plata i omogući ostvarenje prava
              na penziju na osnovu dugogodišnjeg rada na Višoj ženskoj školi.{" "}
              <br />U njenim slikama uočava se prodor kolorizma. Nastaje{" "}
              <i>Dama sa crnim šeširom na glavi</i>.<br />
              <br />
              <b>PARIZ</b>
              <br />
              <br />
              <div>1910.</div>
              Otvara drugu samostalnu izložbu u Jakopičevom umetničkom paviljonu
              u Ljubljani, u okviru programa Prolećne izložbe. Izlaže 37 slika
              iz perioda 1907–1910. Slovenačka kritika je ne podržava. Ivan
              Cankar takođe piše oštru kritiku o izložbi.
              <br />
              Nadežda posećuje Meštrovićevu izložbu u Zagrebu i o njemu piše
              kritiku punu hvale. <br />
              Posle mnogo truda dobija stipendiju i odlazi za Pariz. Živi u
              ateljeu Ivana Meštrovića u Parizu. Pohađa časove “Academie russe
              (Vassileff)” i izlaže sa Ruskim umetničkim i književnim
              udruženjem. U kontaktu je sa našim umetnicima u Parizu, Brankom
              Popovićem, Miroslavom Kraljevićem, Vladimirom Becićem i Ljubom
              Babićem. Izlaže na Jesenjem salonu dve slike:{" "}
              <i>Bdenje pored mrtvaca</i> i <i>Predgrađe Pirota</i>. Učesnici te
              izložbe su i Bonar, Matis, Kandinski, Laprad, Valmenk, Leže, Vijar
              i dr. Beogradska štampa je zabeležila ovaj Nadeždin važan nastup.
              Učestvuje i na Prvoj internacionalnoj izložbi Ruskog umetničkog i
              književnog udruženja. Pod uticajem francuskih fovista, koje ima
              prilike da upozna, nastaju slike jakog kolorita:{" "}
              <i>Bulonjska šuma</i>, <i>Kej na Seni</i>, <i>Most na Seni</i>,{" "}
              <i>Plaža u Bretanji</i>. <br />
              Na izložbi dalmatinskog društva "Medulić" u Zagrebu koju
              organizuje Ivan Meštrović, izlaže tri pejzaža među kojima i sliku{" "}
              <i>Bogorodičina crkva u Parizu</i>. Članstvo društva "Medulić"
              prošireno je pojedinim srpskim, hrvatskim i slovenačkim
              umetnicima.
              <br />
              <br />
              <div>1911.</div>
              Održana je međunarodna izložba u Rimu. U paviljonu Srbije izlažu i
              hrvatski umetnici što će izaztvati sukobe na kulturnoj i
              političkoj sceni u Hrvatskoj, Srbiji i Austriji. Trebalo je da
              Nadežda Petrović izloži pet slika, međutim posle dve odbijene
              slike od strane domaćeg žirija izložiće samo tri:{" "}
              <i>Beogradska ulica u snegu</i>, <i>Tiljerije na Seni</i> i{" "}
              <i>Bogorodičina crkva u Parizu</i>. Kritika je i ovaj put ne
              primećuje, izuzev Dimitrija Mitrinovića koji o njoj piše kao o
              impresionisti. Umire joj otac Mita Petrović i blizak prijatelj
              Ivan Grohar. Izlaže na Jesenjem salonu gde dobija pohvalne
              kritike. Izlaže i na Salonu internacionalne unije.
              <br />
              <br />
              <b>RAT</b>
              <br />
              <br />
              <div>1912.</div>
              Vraća se u Srbiju. Predaje crtanje na Višoj ženskoj školi.
              Učestvuje u pripremi IV jugoslovenske umetničke izložbe u
              Beogradu. Na izložbi, Nadeždina Jugoslovenska umetnička kolonija
              nastupa sa jugoslovenskim udruženjem "Medulić". Nadežda učestvuje
              sa devet slika iz pariskog perioda. Po prvi put dobija dobre
              kritike. Naročito se izdvaja kritika Moše Pijade i Dimitrija
              Mitrinovića. I sama piše značajnu kritiku izložbe gde iznosi svoje
              stavove o savremenom slikarstvu, toku umetnosti kod nas i u svetu
              kao i principima i načelima umetnosti. Otvara "letnji kurs za
              slikanje". To je godina početka Prvog balkanskog rata u koji se
              Nadežda dobrovoljno prijavljuje da bude bolničarka na frontu.
              Umire Mileva Zorić, majka Nadežde Petrović.
              <br />
              <br />
              <div>1913.</div>
              Slika <i>Vezirov most</i>. U Prizrenu nastaje njena najpoznatija
              fotografija sa fronta u bolničkoj uniformi. Za vreme Drugog
              balkanskog rata ponovo je na frontu. Tad nastaje slika{" "}
              <i>Gračanica</i>. Oporavlja se posle preležanog trbušnog tifusa.
              Nadežda dobija Orden za hrabrost i Crveni krst. Odlazi na kraće
              putovanje sa sestrom Anđom u Veneciju radi oporavka ali brzo se
              vraća zbog iscrpljenosti. Po povratku za Beograd radi ilustracije
              za narodne epske pesme. Postaje prva sekretarka Odbora za
              organizaciju umetničkih poslova Srbije i jugoslovenstva.
              <br />
              <br />
              <div>1914.</div>
              Umire Nadeždina sestra Anđa. Sa najmlađim bratom Rastkom, Nadežda
              odlazi u Veneciju. Posle ubistva Franca Fedinanda u Sarajevu,
              Austro-Ugarska objavljuje rat Srbiji. Nadežda prekida odmor u
              Veneciji i vraća se u Beograd. Tad nastaje slika{" "}
              <i>Fasada crkve sv. Marka u Veneciji</i> kao poslednja uspomena na
              Veneciju.
              <br />
              Po povratku u Beograd kao dobrovoljna bolničarka raspoređena je u
              poljsku bolnicu Dunavske divizije. Nalazi se na ratištu kod
              Mačkovog kamena odakle u pismu rodbini podrobno opisuje čitav
              događaj bitke. <br />
              <div>1915.</div>
              Odlazi u Skoplje. Posle smrti sestre Drage ponovo odlazi na front
              u Prvu rezervnu bolnicu u Valjevu gde počinje velika epidemija
              pegavog tifusa. <br />
              Nastaju slike <i>Ruševine</i> i <i>Valjevska bolnica</i>. U
              prolazu sa ratišta obilazi je Branko Popović, što će ujedno biti
              njihov poslednji susret. <br />
              Nadežda Petrović umire u Valjevu 3. aprila od tifusa.
              <br />
              <br />
              <br />
              <b>
                Izvori: Katarina Ambrozić, Nadežda Petrović, CKZ,
                Jugoslavijapublik, Beograd 1978
                <br />
                Lidija Merenik, Nadežda Petrović, Topy, Vojnoizdavački zavod,
                Beograd 2006
                <br />
                Nadežda Petrović, Nadežda Petrović 1873-1915, MSU, Beograd 1973
                <br />
              </b>
              <br />
              <br />
              <br />
              <br />
              <br />
            </p>
          </div>
          <br />
        </Col>
      </Row>
    </Container>
  );
};

export default NadezdaPetrovicText;
